import React from 'react';
import { noAnswerProvided } from '@/components/staffer/Grading/utils';
import { IQuestionAnswer } from '../types';

const WritingQuestionStudentAnswer = ({ questionAnswer }: { questionAnswer: IQuestionAnswer }) => {
  if (!questionAnswer?.answer) return noAnswerProvided();

  return (
    <div dangerouslySetInnerHTML={{ __html: questionAnswer.answer }} />
  );
};

export default WritingQuestionStudentAnswer;
